import { Injectable } from '@angular/core';
import { CanvasLayer } from '../../global/interfaces/canvas-layer';
import { CanvasService } from './canvas.service';
import { SimulationLoopSettings } from '../interfaces/simulation-loop-settings';
import { PredictorModelState } from '../../state/predictor-model/predictor-model.state';
import { Store } from '@ngxs/store';
import { SimulationTrackerActions } from '../../state/simulation-tracker/simulation-tracker.actions';
import { FeatureCollection, Feature, Point } from 'geojson';
import {
  ScenarioData,
  ScenarioPoint,
} from '../interfaces/scenario-batch-simulation-request';

@Injectable({
  providedIn: 'root',
})
export class SimulationRunGroupService {
  constructor(private canvasService: CanvasService, private store: Store) {}

  public queueSimulationRunGroup(
    simulationId: string,
    loopSettings: SimulationLoopSettings,
    simulationName: string =''
  ) {
    if (simulationId == null) return;

    const visiblePointScenarios: CanvasLayer[] = this.store.selectSnapshot(
      PredictorModelState.visiblePointScenarios
    );

    const fishnetShapeFileName: string = this.store.selectSnapshot(
      PredictorModelState.fishnetShapeFileName
    );

    const collections: FeatureCollection[] = visiblePointScenarios.map(
      (scenario: CanvasLayer) =>
        this.canvasService.getFeatureCollectionByLayerIndex(
          scenario.layerIndex
        ) as FeatureCollection
    );

    const scenarios: ScenarioData[] = collections.map( feature =>
      this.mapFeatureCollectionToGroupData(feature)
    );

    this.store.dispatch(
      new SimulationTrackerActions.CreateSimulationRunGroup(
        simulationId,
        simulationName,
        loopSettings.numberOfIterations, 
        scenarios,
        fishnetShapeFileName
      )
    );
  }

  private mapFeatureCollectionToGroupData(
    collection: FeatureCollection
  ): ScenarioData {
    const scenarioName: string = (collection as any).name ?? 'unknown';

    const points: ScenarioPoint[] = collection.features.map( feature =>
      this.mapFeatureToGroupPoint(feature)
    );

    return { scenarioName, points };
  }

  private mapFeatureToGroupPoint(feature: Feature): ScenarioPoint {
    if (feature.geometry?.type !== 'Point') {
      throw new Error(`Unsupported geometry type: ${feature.geometry?.type}`);
    }

    const geometry: Point = feature.geometry;
    const [x, y] = geometry.coordinates;

    const props: { [key: string]: any } = feature.properties ?? {};

    return {
      x,
      y,
      ...props,
    };
  }
}
